/**
 * @file 404.tsx
 *
 * @fileoverview Custom jobiqo 404 Page Not Found page.
 */
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import redirect from '../lib/redirect';
import Head from 'next/head';
import Layout from '../components/Layout';
import { BoxAction } from '~/vcl/organisms/02-actions/01-box-action';
import NotFoundImageSlot from '~/jobiqo/components/Slots/404ImageSlot';
import { useFrontendConfig } from '~/jobiqo/context/frontendConfig';

export const PageNotFound = () => {
  const intl = useIntl();
  const { JOBS } = useFrontendConfig();

  return (
    <>
      <Head>
        <title key="title">
          {intl.formatMessage({
            id: 'pnf_page_title',
            defaultMessage: 'Page not found',
          })}
        </title>
        <meta name="owner" content="jd-404-error" key="jd-owner" />
      </Head>
      <Layout>
        <BoxAction
          actionText={
            <FormattedMessage
              id="pnf_redirect_button"
              defaultMessage="Go to job search"
            />
          }
          iconColor="primary"
          icon={<NotFoundImageSlot />}
          onClick={() => redirect(JOBS.JOBS_PAGE)}
        >
          <FormattedMessage
            id="pnf_message"
            defaultMessage="The page has not been found"
          />
        </BoxAction>
      </Layout>
    </>
  );
};
